export default "__VITE_ASSET__Bwj3jc_7__"